import { icon } from '../components/icons';
import { eyebrow, mesh } from '../components/primitives';
import {
  INSIGHT_NOTE,
  businessOutcome,
  ctaBand,
  howWeWork,
  impactCards,
  insightCard,
  sigBand,
} from '../components/sections';

/* ============================ CUSTOMERS ============================ */
const INSIGHTS: readonly (readonly [quote: string, label: string])[] = [
  [
    "The opportunity isn't always fixing a broken process. Sometimes it's making an already good process significantly more efficient.",
    'Enterprise property tax operations',
  ],
  [
    'The biggest opportunity is often simple: speed up the processes people already depend on.',
    'Property tax technology evaluation',
  ],
  [
    'Give professionals more time for client work, analysis and billable activity instead of administrative hand-offs.',
    'Enterprise workflow objective',
  ],
  [
    'The technology should fit the way the organization works—not force every office into the same process.',
    'Enterprise workflow principle',
  ],
  [
    "This is the first time I've heard anyone put AI, expertise and workflow together.",
    'Property tax professional, enterprise evaluation',
  ],
  ['This would let our team focus on billable work and the most complex cases.', 'Property tax practice leader'],
];
/** Quote indexes per marquee row. Each set is repeated so the scrolling track loops seamlessly. */
const MARQUEE_ROWS = [
  [[0, 1, 2], 'ltr'],
  [[3, 4, 5], 'rtl'],
] as const;

const quoteSet = (quotes: readonly number[]): string => quotes.map((i) => insightCard(...INSIGHTS[i])).join('');

export function pageCustomers(): string {
  return `
  <section class="hero compact" aria-labelledby="h1">
    ${mesh()}
    <div class="wrap rv">
      ${eyebrow('Real workflows. Measurable impact.')}
      <h1 id="h1">Built with property tax professionals, <span class="grad">around the work they actually do.</span></h1>
      <p class="lede" style="margin-top:24px;max-width:760px">ReTax360 is developed alongside real property tax operations. Every workflow teaches us something: where professionals lose time, where information gets stuck, where automation helps and where human judgment needs to remain in control. Our goal isn't to automate everything. It's to remove unnecessary work from around the people doing the work that matters.</p>
    </div>
  </section>
  <section class="s" aria-labelledby="hear-h">
    <div class="wrap">
      <div class="head rv">${eyebrow('Market insights')}<h2 id="hear-h">What we hear from property tax teams</h2></div>
      ${INSIGHT_NOTE}
      <div class="mq-bar"><button class="mq-toggle" type="button" aria-pressed="false" aria-controls="mq" data-mq-toggle>${icon('pause')}<span>Pause</span></button></div>
      <div class="marquee rv" id="mq" data-marquee>
        ${MARQUEE_ROWS.map(
          ([quotes, dir]) => `
        <div class="mq-row ${dir}">
          <div class="mq-track">
            <div class="mq-set">${quoteSet(quotes)}</div>
            <div class="mq-set" aria-hidden="true">${quoteSet(quotes)}</div>
            <div class="mq-set" aria-hidden="true">${quoteSet(quotes)}</div>
            <div class="mq-set" aria-hidden="true">${quoteSet(quotes)}</div>
          </div>
        </div>`,
        ).join('')}
      </div>
      <p class="fine rv">Anonymized and paraphrased from conversations with property tax teams.</p>
    </div>
  </section>
  <section class="s alt" id="impact" aria-labelledby="impact-h">
    <div class="wrap">${impactCards()}${businessOutcome()}</div>
  </section>
  ${sigBand("Capacity isn't always a headcount problem. Often it's an infrastructure problem.", { dark: true, grad: 'an infrastructure problem.' })}
  ${howWeWork({ full: false })}
  ${ctaBand()}`;
}
